import { isEqual } from "lodash";
import { useState } from "react";

import { CaseDiagnosis, CptCode, CptInput } from "custom-models";

import ModifyDiagnosisView from "./ModifyDiagnosisView";
import { createApiCptList, reduceCptCodes } from "../DiagnosisDialogHelpers";

type CopiedDiagnosisDialogProps = {
  hat: string;
  completeDiagnosis: CaseDiagnosis;
  copiedDiagnosis: CaseDiagnosis;
  onUpdateDiagnosis: Function;
  onResetDiagnosis: Function;
  onCancelDiagnosis?: Function;
  isCorrection?: boolean;
};

const checkDiagDifference = (
  completeDiagnosis: CaseDiagnosis,
  copiedDiagnosis: CaseDiagnosis,
  currCptCodes: CptInput[]
) => {
  const compare = !![
    "diagnosis",
    "comment",
    "microscopic",
    "zsd_code",
    "icd10_code",
  ].find(
    (key) =>
      !isEqual(
        completeDiagnosis[key as keyof CaseDiagnosis],
        copiedDiagnosis[key as keyof CaseDiagnosis]
      )
  );

  return compare
    ? compare
    : !isEqual(completeDiagnosis.cpt_codes, createApiCptList(currCptCodes));
};

const CopiedDiagnosisDialog = ({
  hat,
  completeDiagnosis,
  copiedDiagnosis,
  onUpdateDiagnosis,
  onResetDiagnosis,
  onCancelDiagnosis,
  isCorrection,
}: CopiedDiagnosisDialogProps) => {
  const [cpt, setCpt] = useState<CptInput[]>(
    reduceCptCodes(copiedDiagnosis.cpt_codes || [])
  );

  return (
    <ModifyDiagnosisView
      hat={hat}
      caseId={copiedDiagnosis.case}
      addonDiagnosis={copiedDiagnosis}
      completeDiagnosis={completeDiagnosis}
      onUpdateDiagnosis={onUpdateDiagnosis}
      onUpdateDiagnosisCpt={(codes: CptCode[]) => {
        onUpdateDiagnosis("cpt_codes", codes);
      }}
      onCancelDiagnosis={onCancelDiagnosis}
      cptCodes={cpt}
      setCptCodes={setCpt}
      checkDiagnosisDifference={checkDiagDifference}
      onResetDiagnosis={onResetDiagnosis}
      isCorrection={isCorrection}
    />
  );
};

export default CopiedDiagnosisDialog;
